/* A callback enquiry is a lead, never a paid purchase. No contact data is sent. */
(function () {
  'use strict';
  if (window.amaQuickOrderTrackingLoaded) return;
  window.amaQuickOrderTrackingLoaded = true;
  var key = 'ama_qo_tracking_pending';
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-ama-qo-form]') ||
        form.dataset.amaQoReady !== 'true' || !form.checkValidity()) return;
    try { sessionStorage.setItem(key, String(Date.now())); } catch (_) {}
  }, true);

  if (!document.querySelector('[data-ama-qo-success]')) return;
  try {
    var pending = Number(sessionStorage.getItem(key));
    sessionStorage.removeItem(key);
    // Reloads and unrelated contact forms must not create another conversion.
    if (!pending || Date.now() - pending < 0 || Date.now() - pending > 1800000) return;
  } catch (_) { return; }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'ama_quick_order_success', lead_type: 'callback_request' });
})();
